import { trackEvent } from 'dibs-tracking';

export function orderFeedbackEvent({ action, label }: { action: string; label: string }): void {
    trackEvent(
        {
            action,
            label,
            category: 'seller reviews',
            isInteractiveEvent: true,
        },
        null
    );
}
